import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../images/logo.jpg';
import '../css/new.css';

function FullNavbar() {
  const [expanded, setExpanded] = useState(false);

  const handleNavItemClick = () => setExpanded(false);

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      className="custom-navbar"
      sticky="top"
    >
      <Container fluid>
        <Navbar.Brand as={Link} to="/" onClick={handleNavItemClick}>
          <img src={logo} alt="Logo" height="40" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="navbar-nav"
          onClick={() => setExpanded((prev) => !prev)}
        />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" onClick={handleNavItemClick}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/About" onClick={handleNavItemClick}>
              About
            </Nav.Link>
            <Nav.Link as={Link} to="/Service" onClick={handleNavItemClick}>
              Services
            </Nav.Link>
            <Nav.Link as={Link} to="/Contact" onClick={handleNavItemClick}>
              Contact
            </Nav.Link>
            <Nav.Link as={Link} to="/Gallery" onClick={handleNavItemClick}>
              Gallery
            </Nav.Link>
            <Nav.Link as={Link} to="/Appointment" onClick={handleNavItemClick}>
              Appointment
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default FullNavbar;
